class DeviceMatches {
  static discountCode = "APPEXCLUSIVE10";
  static discountProcent = "10";
  static timerMinutes = 20;
  static debug = false;
  static devices = JSON.parse(sessionStorage.getItem("device_list"));
  static matchedDevices = [];
  static timerId = "initTime17";
  static stickyClosedId = "stickyClosed17";
  static isFirstRenderSlider = true;
  static deviceSlider = null;
  static deviceMap = {
    bewrshc1jvlfavl5: {
      id: "8136411611388",
      name: "Geeni Prisma A21 Smart Bulb - Multicolor and Warm White",
      related: [
        { productId: "4384644989007", variantId: "31352740675663" },
        { productId: "6628294262863", variantId: "39649036206159" },
        { productId: "8088106828028", variantId: "44449445314812" },
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "8305370693884", variantId: "45138686771452" },
        { productId: "4850401181775", variantId: "32807658782799" },
      ],
    },
    odrhfd5d0ak2fp3b: {
      id: "7752466858236",
      name: "Merkury Innovations 720P Camera",
      type: "webp",
      related: [
        { productId: "4381945921615", variantId: "31341859930191" },
        { productId: "4384644989007", variantId: "31352740675663" },
        { productId: "8215276650748", variantId: "44844077777148" },
        { productId: "8210956222716", variantId: "44829321330940" },
        { productId: "8094250369276", variantId: "44472366858492" },
      ],
    },
    "7xdihijnnuambnr2": {
      id: "7607581016316",
      name: "Merkury Innovations 1080p Camera",
      related: [
        { productId: "4850401181775", variantId: "32807658782799" },
        { productId: "4384644989007", variantId: "31352740675663" },
        { productId: "8215276650748", variantId: "44844077777148" },
        { productId: "8210956222716", variantId: "44829321330940" },
        { productId: "8094250369276", variantId: "44472366858492" },
      ],
    },
    bawdr6hlvis7yixw: {
      id: "7607581442300",
      name: "Merkury Innovations A19 Light Bulb, 60W White (1-Pack)",
      related: [
        { productId: "4384644989007", variantId: "31352740675663" },
        { productId: "6628294262863", variantId: "39649036206159" },
        { productId: "8088106828028", variantId: "44449445314812" },
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "8136411611388", variantId: "44629116879100" },
        { productId: "4850401181775", variantId: "32807658782799" },
      ],
    },
    clczbpnx3yimjbcw: {
      id: "4680310063183",
      name: "Geeni Dot Smart Plug",
      related: [
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "2434904391759", variantId: "21552685711439" },
        { productId: "6628294262863", variantId: "39649036206159" },
        { productId: "4660020936783", variantId: "32297298329679" },
        { productId: "8088246157564", variantId: "44449774993660" },
      ],
    },
    G4jwjOhQBYx5b5nw: {
      id: "7607582228732",
      name: "Merkury Innovations A21 Multicolor Light Bulb",
      related: [
        { productId: "6628294262863", variantId: "39649036206159" },
        { productId: "8088106828028", variantId: "44449445314812" },
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "8136411611388", variantId: "44629116879100" },
        { productId: "4850401181775", variantId: "32807658782799" },
      ],
    },
    k1okbbubwccmdcaq: {
      id: "4850423136335",
      name: "Geeni Glimpse 1080p Camera",
      related: [
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "8094251385084", variantId: "44472367775996" },
        { productId: "8305370693884", variantId: "45138686771452" },
        { productId: "4680370815055", variantId: "32334053310543" },
        { productId: "4850401181775", variantId: "32807658782799" },
        { productId: "8071365787900", variantId: "44401167565052" },
      ],
    },
    yk5dijqoa2oy341i: {
      id: "7607579148540",
      name: "Merkury Innovations Indoor/Outdoor Symphony Light Strip (16 ft.)",
      related: [
        { productId: "4384644989007", variantId: "31352740675663" },
        { productId: "6628294262863", variantId: "39649036206159" },
        { productId: "8088106828028", variantId: "44449445314812" },
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "8305370693884", variantId: "45138686771452" },
        { productId: "4850401181775", variantId: "32807658782799" },
      ],
    },
    szqueo9p61yifscy: {
      id: "7607578558716",
      name: "Merkury Innovations Plug",
      related: [
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "2434904391759", variantId: "21552685711439" },
        { productId: "6628294262863", variantId: "39649036206159" },
        { productId: "4660020936783", variantId: "32297298329679" },
        { productId: "8088246157564", variantId: "44449774993660" },
      ],
    },
    EeJJEptgHhZDScTD: {
      id: "485103206440",
      name: "Geeni Spot Plug",
      related: [
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "2434904391759", variantId: "21552685711439" },
        { productId: "6628294262863", variantId: "39649036206159" },
        { productId: "4660020936783", variantId: "32297298329679" },
        { productId: "8088246157564", variantId: "44449774993660" },
      ],
    },
    bwolocfvtdy3w2mk: {
      id: "7607580721404",
      name: "Merkury Innovations 1080P Auto-Tracking Security Camera",
      related: [
        { productId: "4381945921615", variantId: "31341859930191" },
        { productId: "4384644989007", variantId: "31352740675663" },
        { productId: "8215276650748", variantId: "44844077777148" },
        { productId: "8210956222716", variantId: "44829321330940" },
        { productId: "8094250369276", variantId: "44472366858492" },
      ],
    },
    eysxtzvaflhxyzyf: {
      id: "4836701864015",
      name: "Geeni Hawk 3 1080p Outdoor Camera",
      related: [
        { productId: "8607220203772", variantId: "45966877753596" },
        { productId: "8619661132028", variantId: "45995967611132" },
        { productId: "8088106828028", variantId: "44449445314812" },
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "8305370693884", variantId: "45138686771452" },
        { productId: "4850401181775", variantId: "32807658782799" },
      ],
    },
    kcfw92tv9nworwl7: {
      id: "4836701864015",
      name: "Geeni Hawk 3 1080p Outdoor Camera",
      related: [
        { productId: "8607220203772", variantId: "45966877753596" },
        { productId: "8619661132028", variantId: "45995967611132" },
        { productId: "8088106828028", variantId: "44449445314812" },
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "8305370693884", variantId: "45138686771452" },
        { productId: "4850401181775", variantId: "32807658782799" },
      ],
    },
    // bewrshc1jvlfavl5: {
    //   id: '8212624900348',
    //   name: 'Hawk 2 Outdoor Camera',
    //   related: [
    //     { productId: '8607220203772', variantId: '45966877753596' },
    //     { productId: '8619661132028', variantId: '45995967611132' },
    //     { productId: '8088106828028', variantId: '44449445314812' },
    //     { productId: '4821841969231', variantId: '32691873808463' },
    //     { productId: '8305370693884', variantId: '45138686771452' },
    //     { productId: '4850401181775', variantId: '32807658782799' }
    //   ]
    // },
    a9wag4xbx6nhrxwy: {
      id: "2451361300559",
      name: "Geeni Look - Indoor Camera",
      related: [
        { productId: "2451361300559", variantId: "21666897330255" },
        { productId: "6628294262863", variantId: "39649036206159" },
        { productId: "8088106828028", variantId: "44449445314812" },
        { productId: "4821841969231", variantId: "32691873808463" },
        { productId: "8305370693884", variantId: "45138686771452" },
        { productId: "4850401181775", variantId: "32807658782799" },
      ],
    },
    fp9pho5zcgw2harc: {
      id: "4850425430095",
      name: "Geeni Scope 1080p Auto-Tracking Camera",
      related: [
        { productId: "8215276650748", variantId: "44844077777148" },
        { productId: "4384644989007", variantId: "31352740675663" },
        { productId: "4381945921615", variantId: "31341859930191" },
        { productId: "8210956222716", variantId: "44829321330940" },
        { productId: "8094250369276", variantId: "44472366858492" },
      ],
    },
  };


  static async initMatches() {    
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    })

    if (typeof userEmail !== 'string') return false
    
    // TODO uncomment
    this.applyDiscountCode(this.discountCode);
    this.showLoader(true);
    await this.getUserDevices();
    this.getMatchedDevices();

    if (!this.matchedDevices.length) {
      this.showLoader(false);
      return;
    }

    this.connectSplide();
    await this.addDevices();
    this.showLoader(false);
  }

  static isExpireTimer() {    
    const initTime = localStorage.getItem(DeviceMatches.timerId)

    if (initTime) {
      const currentTime = Math.floor(Date.now() / 1000)
      let timeLeft = DeviceMatches.timerMinutes * 60 - (currentTime - initTime)

      if (timeLeft <= 0) {
        return true
      }
    }

    return false;
  }

  static initStickyTimer() {
    if (localStorage.getItem(this.stickyClosedId) && !this.debug) return;

    if (this.isExpireTimer()) return

    initTimer(DeviceMatches.timerMinutes);
    addSticky();

    function addSticky() {
      const markup = /* html */ `
        <style>
          .lav-sticky-wrapper .btn--scroll-top {
            display: none!important
          }
          .lav-sticky-wrapper #SiteFooter {
            margin-bottom: 60px;
          }
          .lav-sticky-wrapper .additional-functional {
            bottom: 90px!important;
          }
          .lav-sticky-wrapper iframe#launcher  {
            bottom: 100px!important;
          }
          .lav-sticky-pdp-wrapper .additional-functional {
            bottom: 140px!important;
          }
          .lav-sticky-pdp-wrapper iframe#launcher  {
            bottom: 150px!important;
          }
          .lav-sticky {
            display: flex;
            align-items: center;
            position: fixed;
            z-index: 120;
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: 8px 8px 0px 0px;
            background: linear-gradient(90deg, #C50717 17%, #F71D2F 44.5%, #DC1122 100%);
            color: #fff;
            padding: 12px 12px 12px 5px;
            transition: .5s;
            transform: translateY(0);
          }
          .lav-sticky_hide {
            transform: translateY(300%);
          }
          .lav-sticky_pdp {
            bottom: 52px;
          }
          .lav-sticky__close {
            line-height: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            right: 15px;
            position: absolute;
            top: 0;
            transform: translateY(-100%);
            width: 25px;
            height: 20px;
            transition: .3s;
            border-radius: 4px 4px 0px 0px;
            background: #DE1223;
            cursor: pointer;
          }
          @media(hover:hover) {
            .lav-sticky__close:hover {
              opacity: 0.7;
            }
          }
          .lav-sticky__icon {
            line-height: 0;
            flex-shrink: 0;
            margin-right: 5px;
          }
          .lav-sticky__info {
            position: relative;
            font-size: 16px;
            font-weight: 700;
            line-height: 22px;
          }
          .lav-sticky__info:before {
            content: '';
            position: absolute;
            left: -3px;
            top: 20px;
            background-image: url("data:image/svg+xml,%3Csvg%20width%3D%22109%22%20height%3D%224%22%20viewBox%3D%220%200%20109%204%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M0.997839%202.8778C0.997839%202.8778%2021.2848%201.91603%2062.9799%201.7128C104.675%201.50956%20108.106%202.64975%20108.106%202.64975%22%20stroke%3D%22%2300B0EE%22%20stroke-width%3D%221.6%22%20stroke-linecap%3D%22round%22/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-size: contain;
            width: 108px;
            height: 4px;
          }
          .lav-sticky__info span {
            font-weight: 800;
            white-space: nowrap;
          }
          .lav-timer {
            text-align: center;
            margin-left: auto;
          }
          .lav-timer__title {
            font-size: 14px;
            font-weight: 700;
            line-height: 1;
            white-space: nowrap;
          }
          .lav-timer__inner {
            display: flex;
            justify-content: center;
            gap: 19px;
            margin-top: 6px;
          }
          .lav-timer__value {
            position: relative;
            display: flex;
            gap: 4px;
          }
          .lav-timer__digit {
            border-radius: 4px;
            background: #fff;
            box-shadow: 0px 1px 2px 0px rgba(2, 63, 136, 0.16);
            color: #000;
            font-size: 20px;
            font-weight: 700;
            line-height: 24px;
            text-transform: uppercase;
            width: 20px;
            height: 26px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .lav-timer__value + .lav-timer__value:before {
            content: '';
            position: absolute;
            left: -8px;
            transform: translateX(-100%);
            top: 7px;
            background-image: url("data:image/svg+xml,%3Csvg%20width%3D%224%22%20height%3D%2219%22%20viewBox%3D%220%200%204%2019%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Ccircle%20cx%3D%222%22%20cy%3D%229.5%22%20r%3D%221.5%22%20fill%3D%22white%22/%3E%3Ccircle%20cx%3D%222%22%20cy%3D%2217.5%22%20r%3D%221.5%22%20fill%3D%22white%22/%3E%3C/svg%3E");
            width: 3px;
            height: 11px;
            background-size: cover;
            background-position: bottom;
          }
        </style>
        
        <div class='lav-sticky'>
          <div class='lav-sticky__close'>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <path d="M5.32465 4.50007L8.82914 0.995468C9.0572 0.767508 9.0572 0.398929 8.82914 0.17097C8.60118 -0.0569899 8.2326 -0.0569899 8.00464 0.17097L4.50004 3.67557L0.995548 0.17097C0.767482 -0.0569899 0.399009 -0.0569899 0.17105 0.17097C-0.0570166 0.398929 -0.0570166 0.767508 0.17105 0.995468L3.67554 4.50007L0.17105 8.00467C-0.0570166 8.23263 -0.0570166 8.6012 0.17105 8.82916C0.284656 8.94288 0.434031 9 0.583299 9C0.732567 9 0.881835 8.94288 0.995548 8.82916L4.50004 5.32456L8.00464 8.82916C8.11835 8.94288 8.26762 9 8.41689 9C8.56616 9 8.71542 8.94288 8.82914 8.82916C9.0572 8.6012 9.0572 8.23263 8.82914 8.00467L5.32465 4.50007Z" fill="white"/>
            </svg>
          </div>
    
          <div class='lav-sticky__icon'>
            <svg width="32" height="48" viewBox="0 0 32 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M26.1278 19.5008H18.0183L19.3686 8.09687C19.373 8.05237 19.3774 7.91943 19.3774 7.87658C19.3774 6.8416 18.5358 6 17.503 6C16.9158 6 16.3554 6.28127 15.9709 6.79656L4.37576 24.0011C4.13514 24.323 4 24.7235 4 25.1262C4 26.1611 4.8416 27.0005 5.87438 27.0005H12.499L11.1306 39.9322C11.1262 39.9724 11.124 40.085 11.124 40.1256C11.124 41.1606 11.9656 42 12.9984 42C13.5856 42 14.1459 41.7187 14.5195 41.2194L27.6242 22.4981C27.8649 22.1762 28 21.7757 28 21.373C28.0022 20.3424 27.1628 19.5008 26.1278 19.5008Z" fill="white" fill-opacity="0.12"/>
              <path d="M29.5037 18.0011H18.6911L20.4915 2.79582C20.4973 2.7365 20.5032 2.55924 20.5032 2.50211C20.5032 1.12214 19.3811 0 18.004 0C17.221 0 16.4739 0.375023 15.9612 1.06208L0.501007 24.0015C0.180187 24.4307 0 24.9647 0 25.5016C0 26.8815 1.12214 28.0007 2.49918 28.0007H11.332L9.50741 45.243C9.50155 45.2965 9.49862 45.4466 9.49862 45.5008C9.49862 46.8808 10.6208 48 11.9978 48C12.7808 48 13.5279 47.625 14.026 46.9592L31.499 21.9974C31.8198 21.5682 32 21.0342 32 20.4973C32.0029 19.1232 30.8837 18.0011 29.5037 18.0011Z" fill="white" fill-opacity="0.12"/>
              <path d="M22.7519 20.0005H17.3455L18.2457 12.3979C18.2487 12.3682 18.2516 12.2796 18.2516 12.2511C18.2516 11.5611 17.6905 11 17.002 11C16.6105 11 16.237 11.1875 15.9806 11.531L8.2505 23.0007C8.09009 23.2153 8 23.4823 8 23.7508C8 24.4408 8.56107 25.0004 9.24959 25.0004H13.666L12.7537 33.6215C12.7508 33.6482 12.7493 33.7233 12.7493 33.7504C12.7493 34.4404 13.3104 35 13.9989 35C14.3904 35 14.764 34.8125 15.013 34.4796L23.7495 21.9987C23.9099 21.7841 24 21.5171 24 21.2487C24.0015 20.5616 23.4419 20.0005 22.7519 20.0005Z" fill="white"/>
            </svg>
          </div>
          
          <div class='lav-sticky__info'>
            Get <span>-${DeviceMatches.discountProcent} % off</span> with code <span>${DeviceMatches.discountCode}</span>
          </div>
    
          <div class='lav-sticky__timer lav-timer'>
            <div class='lav-timer__title'>Limited time offer</div>
    
            <div class='lav-timer__inner'>
              <div class='lav-timer__value lav-minutes'>
                <span class='lav-timer__digit'>-</span>
                <span class='lav-timer__digit'>-</span>
              </div>
    
              <div class='lav-timer__value lav-seconds'>
                <span class='lav-timer__digit'>-</span>
                <span class='lav-timer__digit'>-</span>
              </div>
            </div>
          </div>
        </div>
      `;

      document.body.insertAdjacentHTML("beforeend", markup);
      document.body.classList.add("lav-sticky-wrapper");

      const stickyEl = document.querySelector(".lav-sticky");
      const stickyCloseEl = document.querySelector(".lav-sticky__close");

      if (document.querySelector(".sticky-btn-wrapper")) {
        stickyEl.classList.add("lav-sticky_pdp");
        document.body.classList.add("lav-sticky-pdp-wrapper");
      }

      stickyCloseEl.addEventListener("click", (e) => {
        e.preventDefault();

        if (stickyCloseEl.classList.contains("lav-close-processing")) return;

        stickyCloseEl.classList.add("lav-close-processing");
        localStorage.setItem(DeviceMatches.stickyClosedId, true);

        stickyEl.classList.add("lav-sticky_hide");
        document.body.classList.remove(
          "lav-sticky-wrapper",
          "lav-sticky-pdp-wrapper"
        );

        setTimeout(() => {
          stickyEl.remove();
        }, 600);
      });
    }

    function initTimer(mins = 20) {
      if (!parseInt(mins)) return;
    
      const totalTime = parseInt(mins) * 60;
    
      let initTime = localStorage.getItem(DeviceMatches?.timerId); // Ensure DeviceMatches and timerId exist
      const currentTime = Math.floor(Date.now() / 1000);
    
      if (!initTime) {
        initTime = currentTime;
        localStorage.setItem(DeviceMatches.timerId, initTime);
      } else {
        initTime = parseInt(initTime, 10) || currentTime; // Fallback in case of invalid data
      }
    
      function updateTimerDisplay(timeLeft) {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
    
        document.querySelectorAll(".lav-minutes")?.forEach((el) => {
          el.children[0].textContent = Math.floor(minutes / 10);
          el.children[1].textContent = minutes % 10;
        });
    
        document.querySelectorAll(".lav-seconds")?.forEach((el) => {
          el.children[0].textContent = Math.floor(seconds / 10);
          el.children[1].textContent = seconds % 10;
        });
      }
    
      function countdown() {
        const currentTime = Math.floor(Date.now() / 1000);
        const timeLeft = totalTime - (currentTime - initTime);
    
        if (timeLeft > 0) {
          updateTimerDisplay(timeLeft);
        } else {
          clearInterval(timerInterval); // Stop the timer when it reaches zero
    
          document.querySelector(".lav-sticky")?.classList.add("lav-sticky_hide");
          document.querySelector(".lav-pdp-discount")?.remove();
    
          document.body.classList.remove(
            "lav-sticky-wrapper",
            "lav-sticky-pdp-wrapper"
          );
    
          setTimeout(() => {
            document.querySelector(".lav-sticky")?.remove();
          }, 600);
        }
      }
    
      countdown(); // Initial display update
      const timerInterval = setInterval(countdown, 1000);
    }

  }

  static async addDevices() {
    if (document.querySelector('.lav-fit__gift span:last-child')) {
      document.querySelector('.lav-fit__gift span:last-child').innerText = this.discountCode;
    }

    const allProducts = await this.getAllProductsList();

    for (const device of this.matchedDevices) {
      if (document.querySelectorAll(".lav-device__item").length >= 4) break;
      
      const el = document.createElement("div");
      el.classList.add("lav-device__item");
      el.dataset.productId = device.pid;
      // TODO
      el.style.backgroundImage = `url(https://flopsi69.github.io/crs/geeni/discount10Off/img/products/${device.id}.${
        device.type || "jpg"
      })`;

      el.addEventListener("click", () => {
        if (el.classList.contains("active")) return;

        sessionStorage.setItem("choosenFitDevice", device.pid);

        document.querySelector(".lav-fit__slider .splide__list").innerHTML = "";

        document.querySelector(".lav-device__title span").textContent = device.name;

        document.querySelector(".lav-device__item.active")?.classList.remove("active");
        el.classList.add("active");

        device.related.forEach((product) => {
          const findEl = allProducts.find(
            (item) => item.dataset.productId == product.productId
          );

          if (!findEl) return;

          const el = document.createElement("li");
          el.classList.add("splide__slide", "lav-fit__slide");
          el.innerHTML = findEl.outerHTML;
          el.querySelector('.one-quarter')?.classList.remove('one-quarter');

          document.querySelector(".lav-fit__slider .splide__list").insertAdjacentElement(
            "beforeend",
            el
          );

          this.deviceSlider?.refresh();
        });
      });

      document.querySelector(".lav-device__list").insertAdjacentElement("beforeend", el);
    }

    const choosenFitDeviceEl = document.querySelector(
      `.lav-device__item[data-product-id="${sessionStorage.getItem(
        "choosenFitDevice"
      )}"]`
    );

    if (choosenFitDeviceEl) {
      choosenFitDeviceEl.click();
    } else {
      sessionStorage.removeItem("choosenFitDevice");
      document.querySelector(".lav-device__item").click();
    }

    await waitForSplide();

    this.deviceSlider = new Splide(".lav-fit__slider", {
      autoWidth: true,
      arrows: false,
      pagination: false,
      gap: 8,
    });

    const bar = this.deviceSlider.root.querySelector(".lav-fit__bar");

    this.deviceSlider.on("mounted move refresh", () => {
      var end = this.deviceSlider.Components.Controller.getEnd() + 1;
      var rate = Math.min((this.deviceSlider.index + 1) / end, 1);
      bar.style.left = String(100 * rate) + "%";
      bar.style.width =
        parseInt(100 / this.deviceSlider.Components.Slides.get().length) + "%";
    });

    this.deviceSlider.mount();

    this.isFirstRenderSlider = false;

    document.querySelector(".lav-matches").removeAttribute("style");
    
    return true;

    async function waitForSplide() {
      while (typeof Splide === 'undefined') {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
  }

  static showLoader(isShow = true) {
    const loaderEl = document.querySelector(".lav-matches__preload");
    if (!loaderEl) return;

    if (isShow) {
      loaderEl.style.display = "flex";
    } else {
      loaderEl.remove();
    }
  }

  static async getUserDevices() {
    if (typeof userEmail !== "string") return false;

    this.devices = await getDeviceList(userEmail);
  }

  static getMatchedDevices() {
    Object.keys(this.deviceMap).forEach((key) => {
      if (this.devices.includes(key) || this.debug) {
        this.deviceMap[key].pid = key;
        this.matchedDevices.push(this.deviceMap[key]);
      }
    });
  }

  static applyDiscountCode(discountCode) {
    fetch(`/discount/${discountCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log("Response:", response);
        if (response.redirected) {
          console.log("Discount code applied!");
        } else {
          console.log("Invalid discount code or could not apply the discount.");
        }
      })
      .catch((error) => console.error("Error Discount:", error));
  }

  static async getAllProductsList() {
    const productsArr = await Promise.all([
      parseHTML(1),
      parseHTML(2),
      parseHTML(3),
    ]);

    const productElements = [
      ...productsArr[0],
      ...productsArr[1],
      ...productsArr[2],
    ];

    return productElements;

    async function parseHTML(page) {
      const res = await fetch(
        `https://mygeeni.com/collections/all?page=${page}`
      );
      const data = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");

      const products = doc.querySelectorAll(
        "#AjaxinateLoop .product-grid-item"
      );

      return products;
    }
  }

  static connectSplide() {
    const sliderStyles = document.createElement('link')
    sliderStyles.rel = 'stylesheet'
    sliderStyles.href =
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide-core.min.css'
    document.head.appendChild(sliderStyles)
  
    let sliderScript = document.createElement('script')
    sliderScript.src =
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js'
    document.head.appendChild(sliderScript)
  }

  static addPdpDiscount() {
    if (this.isExpireTimer()) return
    
    const markup = /* html */ `
        <style>
          .lav-pdp-discount {
            gap: 6px;
            margin-top: 6px;
            border-radius: 4px;
            background: linear-gradient(90deg, #C50717 17%, #F71D2F 44.5%, #DC1122 100%);
            display: inline-flex;
            align-items: center;
            padding-left: 6px;
            padding-right: 6px;
          }
          .lav-pdp-discount__icon {
            line-height: 0;
            flex-shrink: 0;
          }
          .lav-pdp-discount__icon svg {
            width: 9px;
          }
          .lav-pdp-discount__caption {
            color: #fff;
            font-size: 12px;
            font-weight: 800;
            line-height: 14px;
            text-transform: uppercase;
          }
          .lav-pdp-discount__caption span {
            font-weight: 400;
          }
        </style>

        <div class='lav-pdp-discount'>
          <div class='lav-pdp-discount__icon'>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none">
              <path d="M14.7519 9.00055H9.34554L10.2457 1.39791C10.2487 1.36825 10.2516 1.27962 10.2516 1.25105C10.2516 0.561069 9.69053 0 9.00201 0C8.61051 0 8.23695 0.187512 7.98059 0.531038L0.250504 12.0007C0.0900934 12.2153 0 12.4823 0 12.7508C0 13.4408 0.561069 14.0004 1.24959 14.0004H5.66599L4.75371 22.6215C4.75078 22.6482 4.74931 22.7233 4.74931 22.7504C4.74931 23.4404 5.31038 24 5.9989 24C6.3904 24 6.76396 23.8125 7.013 23.4796L15.7495 10.9987C15.9099 10.7841 16 10.5171 16 10.2487C16.0015 9.56162 15.4419 9.00055 14.7519 9.00055Z" fill="white"/>
            </svg>
          </div>
          <div class='lav-pdp-discount__caption'>Get -${DeviceMatches.discountProcent} % off with code <span>${DeviceMatches.discountCode}</span></div>
        </div>
      `;

    document.querySelector('.product__price-and-badge').insertAdjacentHTML('beforebegin', markup)
  }
}

if (new URLSearchParams(window.location.search).get('utm_source') === 'app' || sessionStorage.getItem('lav-mobile-app') === 'yes') {
  sessionStorage.setItem('lav-mobile-app', 'yes');
  
  if (location.pathname === '/' || location.pathname === '/index') {
    location.href = '/pages/app-index'
  } else {
    DeviceMatches.initStickyTimer();
  }
  
  if (location.pathname === "/pages/app-index") {
    DeviceMatches.initMatches();
  }
  
  if (document.body.classList.contains('template-product')) {
    DeviceMatches.addPdpDiscount();
  }
}
